import { jwt_decode } from "../vendor/frontend/oidc-client-ts-and-jwt-decode";
export const decodeJwt = jwt_decode;
